import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Pagination from '@components/Pagination';
import { useEventTracking, useForumPosts, useQuery } from '@hooks';
import { forum_path } from '@routes';
import { Page } from '@tracking';

import ForumIndexFilters from '../ForumIndexFilters';
import ForumPostList from '../ForumPostList';
import NewForumPostButton from '../NewForumPostButton';

const PAGE = 'page';
const TOPIC = 'topic';

export default function ForumIndexPage({ order }: { order?: string }) {
  const [searchParams] = useSearchParams();
  const { Track } = useEventTracking({
    page: Page.Forum,
  });

  const query = useQuery();
  const [page, setPage] = useState(query.get(PAGE) ? Number(query.get(PAGE)) : 1);
  const perPage = 20;

  const { data, forumPosts, pagination, areForumPostsLoading } = useForumPosts({
    page,
    perPage,
    order,
    topic: searchParams.get(TOPIC),
  });

  const getPath = (page: number) => (page > 1 ? forum_path({ page }) : forum_path());

  return (
    <Track>
      <div>
        <ForumIndexFilters topEntities={data?.top_entities} />
        <main className="container-padded container">
          <ForumPostList forumPosts={forumPosts} />
          {forumPosts?.length > 0 ? (
            <Pagination paginationData={pagination} setPage={setPage} getPath={getPath} />
          ) : (
            !areForumPostsLoading && (
              <>
                <p className="serif" style={{ textAlign: 'center' }}>
                  No recent posts.
                </p>
                <NewForumPostButton />
              </>
            )
          )}
        </main>
      </div>
    </Track>
  );
}
